import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
const routes: Routes = [];

export const routingModule: ModuleWithProviders<any> = RouterModule.forRoot(routes);
